import { SettingsObject } from '@hooks/useSettings';

export const defaults: Partial<SettingsObject> = {
    showClickAndCollect: false,
    enableEnergyLabelLink: true,
};
